/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StringCriteriaRangeInput
 */
export interface StringCriteriaRangeInput {
    /**
     * 
     * @type {boolean}
     * @memberof StringCriteriaRangeInput
     */
    exclude?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StringCriteriaRangeInput
     */
    from?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StringCriteriaRangeInput
     */
    to?: string | null;
}

export function StringCriteriaRangeInputFromJSON(json: any): StringCriteriaRangeInput {
    return StringCriteriaRangeInputFromJSONTyped(json, false);
}

export function StringCriteriaRangeInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringCriteriaRangeInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
    };
}

export function StringCriteriaRangeInputToJSON(value?: StringCriteriaRangeInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exclude': value.exclude,
        'from': value.from,
        'to': value.to,
    };
}


